import React from 'react';
import PropTypes from 'prop-types';
import {noop} from '../../../../lib/utilities';
function _getInputAttributes(props) {
    var inputAttributes = {};

    if (props.disabled) {
        inputAttributes.disabled = "disabled";
    }

    inputAttributes.checked = props.checked ? 'checked' : '';

    if (props.id) {
        inputAttributes.id = props.id;
    }

    return inputAttributes;
}

function CustomCheckbox(props) {
    let onClick;
    if (!props.disabled && props.onChange) {
        onClick = () => { props.onChange(!props.checked); };
    } else {
        onClick = noop;
    }

    const moduleClassName = props.containerClass || "styled-checkbox";
    const containerClassName = [moduleClassName].concat(props.additionalContainerClasses || []).join(" ");
    const realInputClassName = [moduleClassName + "__real-input"].concat(props.inputClasses || []).join(" ");
    const styledInputClassName = [moduleClassName + "__styled-input"].concat(props.styledInputClasses || []).join(" ");

    return (
        <span className={containerClassName}>
            <input
                className={realInputClassName}
                type="checkbox"
                name={props.name || ''}
                id={props.name || ''}
                readOnly
                {..._getInputAttributes(props)}
            />
            <span className={styledInputClassName} onClick={onClick} />
        </span>
    );
}

CustomCheckbox.propTypes = {
    disabled: PropTypes.bool,
    checked: PropTypes.bool,
    onChange: PropTypes.func,
    inputClasses: PropTypes.array,
    styledInputClasses: PropTypes.array,
    containerClass: PropTypes.string,
    additionalContainerClasses: PropTypes.array,
    name: PropTypes.string,
};

export { CustomCheckbox };
